import { ChangeEvent, Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { MappedWorkplace } from '../../types';
import splitArray from '../../../../utils/splitArray';

interface UseSearchesI {
  workplaces: MappedWorkplace[];
  setWorkplacesSplitted: Dispatch<SetStateAction<MappedWorkplace[][]>>;
  setFilteredWorkplaces: Dispatch<SetStateAction<MappedWorkplace[]>>;
}

export default function useSearches({
  workplaces,
  setWorkplacesSplitted,
  setFilteredWorkplaces,
}: UseSearchesI) {
  const [workplaceCode, setWorkplaceCode] = useState('');
  const [streetName, setStreetName] = useState('');
  const [workplaceName, setWorkplaceName] = useState('');
  const [selectedStatus, setSelectedStatus] = useState<'' | 'Ativo' | 'Inativo'>('');

  const filterWorkplaces = useCallback(() => {
    const filteredWorkplaces = workplaces.filter((wp) => {
      const workplaceCodeFilter = wp.code.toLowerCase().startsWith(String(workplaceCode).toLowerCase());
      const streetNameFilter = wp.streetName.toLowerCase().includes(String(streetName).toLowerCase());
      const workplaceNameFilter = wp.name.toLowerCase().includes(String(workplaceName).toLowerCase());
      const statusFilter = selectedStatus === 'Ativo' ? wp.active : (selectedStatus === 'Inativo' ? !wp.active : true);

      return workplaceCodeFilter && streetNameFilter && workplaceNameFilter && statusFilter;
    });

    const workplacesSplitedbyFilters = splitArray(filteredWorkplaces);
    setWorkplacesSplitted(workplacesSplitedbyFilters);
    setFilteredWorkplaces(workplacesSplitedbyFilters[0]);
  }, [workplaces, setWorkplacesSplitted, setFilteredWorkplaces, workplaceCode, streetName, workplaceName, selectedStatus]);

  useEffect(() => {
    filterWorkplaces();
  }, [filterWorkplaces]);

  const handleWorkplaceCodeChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setWorkplaceCode(event.target.value);
  }, []);

  const handleStreetNameChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setStreetName(event.target.value);
  }, []);

  const handleWorkplaceNameChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setWorkplaceName(event.target.value);
  }, []);

  const handleStatusChange = useCallback((status: '' | 'Ativo' | 'Inativo') => {
    setSelectedStatus(status);
  }, []);

  return {
    selectedStatus,
    handleStatusChange,
    workplaceCode,
    handleWorkplaceCodeChange,
    streetName,
    handleStreetNameChange,
    workplaceName,
    handleWorkplaceNameChange,
    setWorkplaceCode,
    setWorkplaceName,
    setSelectedStatus,
    setStreetName,
  };
}
